var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNowwalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79753e-06 32C4.89568e-06 8 8.00001 2.73372e-06 32 4.83187e-06C56 6.93001e-06 64 8.00001 64 32C64 56 56 64 32 64C8 64 6.99382e-07 56 2.79753e-06 32Z",
    fill: "#6CB0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79753e-06 32C4.89568e-06 8 8.00001 2.73372e-06 32 4.83187e-06C56 6.93001e-06 64 8.00001 64 32C64 56 56 64 32 64C8 64 6.99382e-07 56 2.79753e-06 32Z",
    fill: "#00A05C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.654 25.7405H22.8609C22.4019 25.7405 22.0301 25.3628 22.0301 24.8965C22.0301 24.4303 22.4019 24.0526 22.8609 24.0526H42.7993C43.2583 24.0526 43.6301 23.6749 43.6301 23.2086C43.6301 21.8103 42.5143 20.6768 41.1378 20.6768H22.0301C20.1946 20.6768 18.707 22.188 18.707 24.0526V40.9317C18.707 42.7963 20.1946 44.3075 22.0301 44.3075H42.654C44.1088 44.3075 45.2916 43.1719 45.2916 41.7757V28.2724C45.2916 26.8761 44.1088 25.7405 42.654 25.7405ZM40.307 36.7119C39.3896 36.7119 38.6455 35.9561 38.6455 35.024C38.6455 34.092 39.3896 33.3361 40.307 33.3361C41.2245 33.3361 41.9686 34.092 41.9686 35.024C41.9686 35.9561 41.2245 36.7119 40.307 36.7119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowwalletIcon);
export default __webpack_public_path__ + "static/media/nowwallet-icon.fff1617af83ac0c9c41953081fd6a8d2.svg";
export { ForwardRef as ReactComponent };